"use client";

import { useParams, useRouter, useSearchParams, useSelectedLayoutSegment } from "next/navigation";

export function CategoryMenu({ label, value, className }: { label: string; value: string; className?: string }) {
  const { year } = useParams();
  const router = useRouter();
  const searchParams = useSearchParams();
  const category = useSelectedLayoutSegment() ?? "";
  const params = new URLSearchParams(searchParams.toString());
  return (
    <input
      type="radio"
      name="options"
      key={value}
      value={value}
      aria-label={label}
      className={`${className} ${value === category || "btn-outline"}`}
      onClick={() => router.push(`/${year}/team/${value}?${params.toString()}`, { scroll: false })}
    />
  );
}
